import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { Autocomplete } from "../autocomplete";
import { usePlaceAutocomplete } from "./hooks";
import type { PlaceAutocompleteProps } from "./types";

// The inner component assumes the context is available
export const PlaceAutocomplete: React.FC<PlaceAutocompleteProps> = t0 => {
  const $ = _c(40);
  let onItemRemove;
  let onPlaceSelect;
  let onSelectionMade;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== t0) {
    ({
      onPlaceSelect,
      placeholder: t1,
      className: t2,
      inputProps: t3,
      selectedItems: t4,
      onItemRemove,
      showChips: t5,
      filterField: t6,
      onSelectionMade,
      initialValue: t7,
      autoFocus: t8,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = onItemRemove;
    $[2] = onPlaceSelect;
    $[3] = onSelectionMade;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    onItemRemove = $[1];
    onPlaceSelect = $[2];
    onSelectionMade = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
  }
  const placeholder = t1 === undefined ? "Enter a location" : t1;
  const className = t2 === undefined ? "" : t2;
  let t9;
  if ($[13] !== t3) {
    t9 = t3 === undefined ? {} : t3;
    $[13] = t3;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const inputProps = t9;
  let t10;
  if ($[15] !== t4) {
    t10 = t4 === undefined ? [] : t4;
    $[15] = t4;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const selectedItems = t10;
  const showChips = t5 === undefined ? false : t5;
  const filterField = t6 === undefined ? false : t6;
  const initialValue = t7 === undefined ? "" : t7;
  const autoFocus = t8 === undefined ? false : t8;
  const [isValueSelected, setIsValueSelected] = useState(false);
  const {
    inputValue,
    suggestionItems,
    handleInputChange,
    handlePlaceSelect,
    clearInput,
    isReady
  } = usePlaceAutocomplete(onPlaceSelect, isValueSelected, onSelectionMade, initialValue);
  let t11;
  if ($[17] !== selectedItems) {
    t11 = selectedItems.map(_temp);
    $[17] = selectedItems;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const selectedAutocompleteItems = t11;
  let t12;
  if ($[19] !== inputProps) {
    t12 = inputProps || {};
    $[19] = inputProps;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12) {
    t13 = {
      "aria-label": "Location",
      ...t12
    };
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== autoFocus || $[24] !== className || $[25] !== clearInput || $[26] !== filterField || $[27] !== handleInputChange || $[28] !== handlePlaceSelect || $[29] !== inputValue || $[30] !== isReady || $[31] !== isValueSelected || $[32] !== onItemRemove || $[33] !== placeholder || $[34] !== props || $[35] !== selectedAutocompleteItems || $[36] !== showChips || $[37] !== suggestionItems || $[38] !== t13) {
    t14 = <Autocomplete value={inputValue} items={suggestionItems} placeholder={placeholder} className={className} isReady={isReady} isValueSelected={isValueSelected} onInputChange={handleInputChange} onItemSelect={handlePlaceSelect} onClear={clearInput} onValueSelectedChange={setIsValueSelected} inputProps={t13} selectedItems={selectedAutocompleteItems} onItemRemove={onItemRemove} showChips={showChips} filterField={filterField} autoFocus={autoFocus} {...props} />;
    $[23] = autoFocus;
    $[24] = className;
    $[25] = clearInput;
    $[26] = filterField;
    $[27] = handleInputChange;
    $[28] = handlePlaceSelect;
    $[29] = inputValue;
    $[30] = isReady;
    $[31] = isValueSelected;
    $[32] = onItemRemove;
    $[33] = placeholder;
    $[34] = props;
    $[35] = selectedAutocompleteItems;
    $[36] = showChips;
    $[37] = suggestionItems;
    $[38] = t13;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  return t14;
};

// // The wrapper decides whether to provide the context
// export const PlaceAutocomplete: React.FC<PlaceAutocompleteProps> = props => {
// 	if (props.filterField) {
// 		return <PlaceAutocompleteInner {...props} />;
// 	}
// 	return (
// 		<MapProvider>
// 			<PlaceAutocompleteInner {...props} />
// 		</MapProvider>
// 	);
// };
function _temp(item) {
  return {
    id: item.id,
    text: item.displayName,
    isPlaceholder: false
  };
}